exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-100p[data-v-b1b1d68c]{height:100%}.header-table-divider[data-v-b1b1d68c]{margin-top:2%}.btn-new-identity[data-v-b1b1d68c]{background-color:#0032a0!important;color:#fff}.v-btn[data-v-b1b1d68c]{text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b1b1d68c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/authandvideocall/AuthAndVideoCallApprove.vue
// module id = 1024
// module chunks = 0